<div class="app-body">
  <main class="main d-flex align-items-center min-vh-100">
    <div class="container text-center">
      <div class="spinner-border text-primary">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3">Completing sign in...</p>
    </div>
  </main>
</div>
